import React, { FC, useCallback } from 'react'
import { cn } from 'shared/utils'
import { useNavigate } from 'react-router-dom'

import { TSearchResults } from 'shared/types'
import { SearchListExtendedProps } from './SearchListExtended.props'
import { getSearchItemData } from 'shared/utils/getSearchItemData'
import SearchItem from '../SearchItem/SearchItem'
import { useHeaderSearch } from 'modulesCommon/serviceHooks'

const SearchListExtended: FC<SearchListExtendedProps> = ({
  titles,
  itemIndex,
  listItems,
  dataTest,
  isArchivedShow,
  toggleArchivedShow
}) => {
  const { isGlobalHubPage } = useHeaderSearch()
  const navigate = useNavigate()
  const archivedCount = listItems?.filter(({ active }) => !active).length

  const onItemClick = useCallback(
    (item) => {
      if (isGlobalHubPage) {
        navigate(`/globalhub/projects/${item.campaign_id}`)
      } else {
        navigate(`/projects/${item.campaign_id}`)
      }
    },
    [isGlobalHubPage, navigate]
  )

  return (
    <div className="search-menu__container">
      {titles.length > 1 && (
        <div className="search-menu-header" onClick={toggleArchivedShow}>
          <div className="search-menu-header__title">
            {titles[itemIndex] === 'campaigns' ? 'Active Projects' : titles[itemIndex]}
          </div>
          {archivedCount ? (
            <div className="search-menu-header__archived">
              {isArchivedShow ? `(hide ${archivedCount} archived)` : `(show ${archivedCount} archived)`}
            </div>
          ) : null}
        </div>
      )}

      <ul className="search-menu__list" data-test={`${dataTest}_${titles[itemIndex]}-block`}>
        {listItems.length > 0 ? (
          listItems?.map((item: TSearchResults) =>
            item.active || isArchivedShow ? (
              <li
                onClick={() => onItemClick(item)}
                data-test={`${dataTest}_item`}
                key={item.id}
                className={cn('search-menu__item search-menu__item--clickable', {
                  'search-menu__item--archived': !item.active
                })}
              >
                <SearchItem
                  {...getSearchItemData(item)}
                  isProduct={item.__typename === 'Product'}
                  dataTestPrefix={dataTest}
                />
              </li>
            ) : null
          )) : (
          <li className={'search-menu__item'}>No results</li>
        )}
      </ul>
    </div>
  )
}
export default SearchListExtended
